import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCombosListControllerModule } from './controllers/ProgramsCombosListController';

export const ProgramsCombosListView = angular
  .module('acme.view.application.programs.combos.list', [
    uiRouter,
    'ui.bootstrap',
    ProgramsCombosListControllerModule,
    'acme.common.service.api',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.combos.list',
      url: '/list',
      views: {
        'subview-main': {
          controller: 'ProgramsCombosListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/combos/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Combos',
        permissions: ['COMBO_TEMPLATE_VIEW'],
      },
    });
  }).name;
